module.exports = __webpack_public_path__ + "img/Delivery fee Icon - charcoal.941b3317.svg";